import { render, staticRenderFns } from "./AssistMaterialVideo.vue?vue&type=template&id=cf44da72&scoped=true&lang=pug&"
import script from "./AssistMaterialVideo.vue?vue&type=script&lang=ts&"
export * from "./AssistMaterialVideo.vue?vue&type=script&lang=ts&"
import style0 from "./AssistMaterialVideo.vue?vue&type=style&index=0&id=cf44da72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf44da72",
  null
  
)

export default component.exports